"use strict";
Shopify.contentCreator.accordion = {
	init: function() {
		var t = $(".accordion > dt > a, [data-cc-accordion] > dt > a");
		$(".accordion > dd, [data-cc-accordion] > dd").attr("aria-hidden", !0), t.attr("aria-expanded", !1), t.on("click", function() {
			var o = $(this).attr("aria-expanded") === "false";
			return $(this).attr("aria-expanded", o), $(this).parent().next().slideToggle(function() {}), $(this).parent().next().attr("aria-hidden", !o), !1
		}), t.on("keydown", function(o) {
			var a = o.keyCode || e.which;
			a === 13 && $(this).trigger("activate")
		})
	},
	unload: function() {
		$(".accordion > dt > a, [data-cc-accordion] > dt > a").off("click activate"), $(".accordion > dt > a, [data-cc-accordion] > dt > a").off("keydown")
	}
}, Shopify.contentCreator.slideshow = {
	init: function() {
		$(".slider, .flexslider").find("li").unwrap(), $(".slider, .flexslider").flickity({
			pageDots: !0,
			lazyLoad: 2
		})
	}
}, Shopify.theme.animation = {
	init: function() {
		$("[data-scroll-class]").waypoint(function() {
			var t = $(this.element).data("scroll-class");
			$(this.element).addClass("animated").addClass(t)
		}, {
			offset: "70%"
		})
	},
	slideTransition: function(t, o, a) {
		t.parents(".flickity-enabled").find(".animated").removeClass("animated " + o), t.addClass("animated").addClass(o)
	},
	unload: function(t) {
		t.data("scroll-class", "")
	}
};
var deferred = {};
Shopify.theme.asyncView = {
	load: function(t, o) {
		var a = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {},
			r;
		if (t in deferred) return deferred[t];
		var s = $.Deferred();
		if (deferred[t] = s, a.hash && (r = sessionStorage.getItem(t), r)) {
			var c = JSON.parse(r);
			if (a.hash === c.options.hash) return delete deferred[t], s.resolve(c).promise()
		}
		return $.ajax({
			url: t,
			cache: !1,
			data: "view=".concat(o),
			dataType: "html",
			headers: {
				"cache-control": "no-cache"
			},
			success: function(d) {
				var p = document.createElement("div");
				p.innerHTML = d;
				var f = JSON.parse(p.querySelector("[data-options]").innerHTML),
					u = p.querySelectorAll("[data-html]"),
					h = {};
				if (u.length === 1 && u[0].getAttribute("data-html") === "") h = u[0].innerHTML;
				else
					for (var m = 0; m < u.length; m++) h[u[m].getAttribute("data-html")] = u[m].innerHTML;
				if (a.hash) try {
					sessionStorage.setItem(t, JSON.stringify({
						options: f,
						html: h
					}))
				} catch (y) {
					console.error(y)
				}
				return delete deferred[t], s.resolve({
					options: f,
					html: h
				})
			},
			error: function() {
				return delete deferred[t], s.reject()
			}
		}), s.promise()
	}
}, Shopify.theme.breadcrumbs = {
	init: function(t) {
		if (t > 1) {
			var o = document.querySelector("[data-breadcrumb-text]"),
				a = document.querySelector(".paginate").dataset.currentPage ? document.querySelector(".paginate").dataset.currentPage : 1,
				r = document.querySelector(".paginate").dataset.paginatePages;
			document.querySelector(".js-breadcrumb-text").classList.remove("is-hidden"), o.innerHTML = "".concat(Shopify.translation.page_text, " ").concat(a, " ").concat(Shopify.translation.of_text, " ").concat(r)
		}
	},
	unload: function(t) {
		document.querySelector(".js-breadcrumb-text").classList.add("is-hidden")
	}
}, Shopify.theme.dropdownMenu = function() {
	var n = {
		$submenuInput: $(".has-submenu input")
	};
	n.$submenuInput.on("click", function() {
		if ($(this).hasClass("is-opened")) {
			var t = $(this).closest("navbar-link").attr("href");
			window.location.href = t
		} else $(this).addClass("is-opened")
	})
}, Shopify.theme.newsletterAjaxForm = {
	init: function() {
		var t = $(".newsletter-form__wrapper .contact-form");
		t.each(function() {
			var o = $(this);
			o.on("submit", function(a) {
				$('input[name="challenge"]', o).val() !== "true" && ($.ajax({
					type: o.attr("method"),
					url: o.attr("action"),
					data: o.serialize(),
					success: function(s) {
						o.fadeOut("slow", function() {
							o.prev(".form__success-message").html(Shopify.translation.newsletter_form_success)
						})
					},
					error: function(s) {
						$('input[name="challenge"]', o).val("true"), o.submit()
					}
				}), a.preventDefault())
			})
		})
	},
	unload: function() {
		var t = $(".newsletter-form__wrapper .contact-form"),
			o = t.find(":submit");
		o.off()
	}
}, Shopify.theme.getSectionData = function(n) {
	var t = n.attr("id").replace("shopify-section-", ""),
		o = n.find("[data-section-data][data-section-id=" + t + "]").first();
	if (!o) return {};
	var a = o.data("section-data") || o.html();
	try {
		return JSON.parse(a)
	} catch (r) {
		return console.warn("Sections: invalid section data found. ".concat(r.message)), {}
	}
}, Shopify.theme.infiniteScroll = {
	init: function() {
		this.defaults = {
			grid: "[data-load-more--grid]",
			gridItems: "[data-load-more--grid-item]"
		}, $("body").on("click", "[data-load-more]", function(t) {
			t.preventDefault();
			var o = $(this),
				a = o.attr("href");
			Shopify.theme.infiniteScroll.loadNextPage(a, o)
		}), $("body").on("click", "[data-load-more-infinite]", function(t) {
			return Shopify.theme.infiniteScroll.enableInfinite(), $(this).remove(), t.stopPropagation(), !1
		}), $("[data-load-infinite-scroll]").length && Shopify.theme.infiniteScroll.enableInfinite()
	},
	loadNextPage: function(t, o) {
		var a = this;
		$.ajax({
			type: "GET",
			dataType: "html",
			url: t,
			beforeSend: function() {
				o.addClass("is-loading")
			},
			success: function(s) {
				o.removeClass("is-loading");
				var c = $(s).find(a.defaults.gridItems),
					l = $(s).find("[data-load-more]").attr("href");
				$("[data-load-more]").attr("href", l), $(a.defaults.grid).first().append(c), typeof l == "undefined" && $("[data-load-more]").addClass("is-hidden")
			},
			error: function(s, c, l) {
				console.log(s), console.log(c), console.log(l), location.replace(location.protocol + "//" + location.host + filterURL)
			}
		})
	},
	enableInfinite: function() {
		var t = new Waypoint.Infinite({
			element: $(this.defaults.grid)[0],
			items: "[data-load-more--grid-item]",
			more: "[data-load-infinite]",
			loadingClass: "loading-in-progress",
			onBeforePageLoad: function() {
				$("[data-load-infinite]").removeClass("is-hidden")
			},
			onAfterPageLoad: function(a) {}
		})
	},
	unload: function() {
		$("[data-load-more]").off(), $("[data-load-infinite]").off()
	}
}, Shopify.theme.flickityIosFix = function() {
	var n = !1,
		t;
	document.body.addEventListener("touchstart", function(o) {
		if ($(this).closest(".flickity-slider")) n = !0;
		else {
			n = !1;
			return
		}
		t = {
			x: o.touches[0].pageX,
			y: o.touches[0].pageY
		}
	}), document.body.addEventListener("touchmove", function(o) {
		if (!!(n && o.cancelable)) {
			var a = {
				x: o.touches[0].pageX - t.x,
				y: o.touches[0].pageY - t.y
			};
			Math.abs(a.x) > 7 && o.preventDefault()
		}
	}, {
		passive: !1
	})
}, Shopify.theme.loadScript = function(n, t, o) {
	Shopify.theme[n] || $.ajax({
		url: t,
		dataType: "script",
		success: o,
		async: !1
	})
}, Shopify.theme.updateOptionsInSelector = function(n, t) {
	switch (n) {
		case 0:
			var o = "root",
				a = $(t + " .single-option-selector:eq(0)");
			break;
		case 1:
			var o = $(t + " .single-option-selector:eq(0)").val(),
				a = $(t + " .single-option-selector:eq(1)");
			break;
		case 2:
			var o = $(t + " .single-option-selector:eq(0)").val();
			o += " / " + $(t + " .single-option-selector:eq(1)").val();
			var a = $(t + " .single-option-selector:eq(2)")
	}
	var r = Shopify.optionsMap[o];
	$(t + ' .swatch[data-option-index="' + n + '"] .swatch-element').each(function() {
		$.inArray($(this).attr("data-value"), r) !== -1 ? $(this).removeClass("soldout").find(":radio").removeAttr("disabled", "disabled").removeAttr("checked") : $(this).addClass("soldout").find(":radio").removeAttr("checked").attr("disabled", "disabled")
	})
}, Shopify.linkOptionSelectors = function(n, t) {
	Shopify.optionsMap = {};
	for (var o = 0; o < n.variants.length; o++) {
		var a = n.variants[o];
		if (a.available) {
			if (Shopify.optionsMap.root = Shopify.optionsMap.root || [], Shopify.optionsMap.root.push(a.option1), Shopify.optionsMap.root = Shopify.uniq(Shopify.optionsMap.root), n.options.length > 1) {
				var r = a.option1;
				Shopify.optionsMap[r] = Shopify.optionsMap[r] || [], Shopify.optionsMap[r].push(a.option2), Shopify.optionsMap[r] = Shopify.uniq(Shopify.optionsMap[r])
			}
			if (n.options.length === 3) {
				var r = a.option1 + " / " + a.option2;
				Shopify.optionsMap[r] = Shopify.optionsMap[r] || [], Shopify.optionsMap[r].push(a.option3), Shopify.optionsMap[r] = Shopify.uniq(Shopify.optionsMap[r])
			}
		}
	}
	Shopify.theme.updateOptionsInSelector(0, t), n.options.length > 1 && Shopify.theme.updateOptionsInSelector(1, t), n.options.length === 3 && Shopify.theme.updateOptionsInSelector(2, t), $(t + " .single-option-selector:eq(0)").change(function() {
		return Shopify.theme.updateOptionsInSelector(1, t), n.options.length === 3 && Shopify.theme.updateOptionsInSelector(2, t), !0
	}), $(t + " .single-option-selector:eq(1)").change(function() {
		return n.options.length === 3 && Shopify.theme.updateOptionsInSelector(2, t), !0
	})
}, Shopify.theme.applyMasonry = function(n, t) {
	var o = $(".gallery-type--masonry");
	o.length > 0 && o.imagesLoaded().progress(function() {
		o.isotope({
			layoutMode: "masonry",
			itemSelector: n,
			percentPosition: !0,
			masonry: {
				columnWidth: n,
				gutter: t
			}
		})
	})
}, Shopify.theme.applyHorizontalMasonry = function() {
	var n = $(".gallery-type--horizontal-masonry");
	n.find(".gallery__item").each(function(t) {
		var o = $(this),
			a, r;
		setTimeout(function() {
			a = o.find("img").width(), r = o.find("img").height(), o.css("flex-basis", a * 200 / r), o.css("flex-grow", a * 200 / r), o.find("i").css("padding-bottom", r / a * 100 + "%")
		}, 100)
	})
}, Shopify.theme.mobileMenu = {
	init: function() {
		this.$mobileMenuToggle = $("[data-show-mobile-menu]"), this.$mobileMenuIcon = $(".mobile-menu__toggle-icon"), this.$mobileDropDownToggle = $(".mobile-menu .close-dropdown"), $("body").on("click", '[data-show-mobile-menu="false"]', function() {
			Shopify.theme.mobileMenu.open()
		}), $("body").on("click", '[data-show-mobile-menu="true"]', function() {
			Shopify.theme.mobileMenu.close()
		}), $("body").on("click", ".mobile-menu-link", function(t) {
			//t.preventDefault()
		}), Shopify.theme.jsHeader.enable_sticky === !0 && this.enableSticky()
	},
	open: function() {
		var t = window.scrollY;
		$("body").attr("data-current-position", t);
		var o = 0,
			a = parseInt($(".mobile-header").height());
		typeof Shopify.theme.jsAnnouncementBar != "undefined" && Shopify.theme.jsAnnouncementBar.enable_sticky && (o = Shopify.theme.jsAnnouncementBar.getAnnouncementHeight()), $(".mobile-menu").css({
			height: "calc(100vh - ".concat(a + o, "px)")
		}), this.$mobileMenuIcon.addClass("is-active"), $("[data-show-mobile-menu]").attr("data-show-mobile-menu", !0), typeof Shopify.theme.jsAjaxCart != "undefined" && (Shopify.theme.jsAjaxCart.hideMiniCart(), Shopify.theme.jsAjaxCart.hideDrawer()), setTimeout(function() {
			$("body").addClass("mobile-menu--opened")
		}, 10)
	},
	close: function() {
		$("body").removeClass("mobile-menu--opened");
		var t = $("body").data("current-position");
		window.scrollTo(0, t), this.$mobileMenuIcon.removeClass("is-active"), $("[data-show-mobile-menu]").attr("data-show-mobile-menu", !1)
	},
	enableSticky: function() {
		Shopify.theme.jsHeader.disableSticky();
		var t = $("#mobile-header"),
			o = 0;
		typeof Shopify.theme.jsAnnouncementBar != "undefined" && Shopify.theme.jsAnnouncementBar.enable_sticky && (o = Shopify.theme.jsAnnouncementBar.getAnnouncementHeight()), t.addClass("sticky--enabled"), t.sticky({
			wrapperClassName: "header-sticky-wrapper",
			zIndex: 40,
			topSpacing: o
		}).on("sticky-start", function() {
			var a = $("#mobile-header").height(),
				r = $(".announcement-sticky-wrapper").height(),
				s = a + r;
			t.parent().parent().find(".search-overlay").addClass("sticky-search").css("top", s + "px")
		}).on("sticky-end", function() {
			t.parent().parent().find(".search-overlay").removeClass("sticky-search").css("top", "100%"), setTimeout(function() {
				t.sticky("update")
			}, 250), t.find(".sticky-menu-wrapper").removeClass("is-visible")
		})
	},
	disableSticky: function() {
		var t = $("#mobile-header");
		t.unstick(), t.removeClass("sticky--enabled"), setTimeout(function() {
			$(".header-sticky-wrapper").css("height", "auto")
		}, 250)
	},
	unload: function(t) {
		$("[data-mobilemenu-toggle]").off(), $(".mobile-menu__toggle-icon").off(), $(".mobile-menu .close-dropdown").off(), this.disableSticky()
	}
}, Shopify.theme.objectFitImages = {
	init: function() {
		objectFitImages(), Shopify.theme_settings.image_loading_style == "color" && this.calculateAspectRatio()
	},
	calculateAspectRatio: function() {
		for (var t = document.querySelectorAll("[data-calculate-aspect-ratio]"), o = 0; o < t.length; o++) {
			var a = t[o].firstElementChild,
				r = a.getAttribute("width") / a.getAttribute("height"),
				s = a.height * r;
			t[o].style.maxWidth = "".concat(Math.floor(s), "px")
		}
		document.addEventListener("lazyloaded", function(c) {
			c.srcElement.parentNode.style.background = "none"
		})
	},
	unload: function() {}
};

function floatToString(n, t) {
	var o = n.toFixed(t).toString();
	return o.match(/^\.\d+/) ? "0" + o : o
}
if (typeof Shopify == "undefined") var Shopify = {};
if (Shopify.each = function(n, t) {
		for (var o = 0; o < n.length; o++) t(n[o], o)
	}, Shopify.map = function(n, t) {
		for (var o = [], a = 0; a < n.length; a++) o.push(t(n[a], a));
		return o
	}, Shopify.arrayIncludes = function(n, t) {
		for (var o = 0; o < n.length; o++)
			if (n[o] == t) return !0;
		return !1
	}, Shopify.uniq = function(n) {
		for (var t = [], o = 0; o < n.length; o++) Shopify.arrayIncludes(t, n[o]) || t.push(n[o]);
		return t
	}, Shopify.isDefined = function(n) {
		return typeof n != "undefined"
	}, Shopify.getClass = function(n) {
		return Object.prototype.toString.call(n).slice(8, -1)
	}, Shopify.extend = function(n, t) {
		function o() {}
		o.prototype = t.prototype, n.prototype = new o, n.prototype.constructor = n, n.baseConstructor = t, n.superClass = t.prototype
	}, Shopify.locationSearch = function() {
		return window.location.search
	}, Shopify.locationHash = function() {
		return window.location.hash
	}, Shopify.replaceState = function(n) {
		window.history.replaceState({}, document.title, n)
	}, Shopify.urlParam = function(n) {
		var t = RegExp("[?&]" + n + "=([^&#]*)").exec(Shopify.locationSearch());
		return t && decodeURIComponent(t[1].replace(/\+/g, " "))
	}, Shopify.newState = function(n, t) {
		var o;
		return o = Shopify.urlParam(n) ? Shopify.locationSearch().replace(RegExp("(" + n + "=)[^&#]+"), "$1" + t) : Shopify.locationSearch() === "" ? "?" + n + "=" + t : Shopify.locationSearch() + "&" + n + "=" + t, o + Shopify.locationHash()
	}, Shopify.setParam = function(n, t) {
		Shopify.replaceState(Shopify.newState(n, t))
	}, Shopify.Product = function(n) {
		Shopify.isDefined(n) && this.update(n)
	}, Shopify.Product.prototype.update = function(n) {
		for (var t in n) this[t] = n[t]
	}, Shopify.Product.prototype.optionNames = function() {
		return Shopify.getClass(this.options) == "Array" ? this.options : []
	}, Shopify.Product.prototype.optionValues = function(n) {
		if (!Shopify.isDefined(this.variants)) return null;
		var t = Shopify.map(this.variants, function(o) {
			var a = "option" + (n + 1);
			return o[a] == null ? null : o[a]
		});
		return t[0] == null ? null : Shopify.uniq(t)
	}, Shopify.Product.prototype.getVariant = function(n) {
		var t = null;
		return n.length != this.options.length || Shopify.each(this.variants, function(o) {
			for (var a = !0, r = 0; r < n.length; r++) {
				var s = "option" + (r + 1);
				o[s] != n[r] && (a = !1)
			}
			return a == 1 ? void(t = o) : void 0
		}), t
	}, Shopify.Product.prototype.getVariantById = function(n) {
		for (var t = 0; t < this.variants.length; t++) {
			var o = this.variants[t];
			if (n == o.id) return o
		}
		return null
	}, Shopify.money_format = "${{amount}}", Shopify.formatMoney = function(n, t) {
		function o(l, d) {
			return typeof l == "undefined" ? d : l
		}

		function a(l, d, p, f) {
			if (d = o(d, 2), p = o(p, ","), f = o(f, "."), isNaN(l) || l == null) return 0;
			l = (l / 100).toFixed(d);
			var u = l.split("."),
				h = u[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + p),
				m = u[1] ? f + u[1] : "";
			return h + m
		}
		typeof n == "string" && (n = n.replace(".", ""));
		var r = "",
			s = /\{\{\s*(\w+)\s*\}\}/,
			c = t || this.money_format;
		switch (c.match(s)[1]) {
			case "amount":
				r = a(n, 2);
				break;
			case "amount_no_decimals":
				r = a(n, 0);
				break;
			case "amount_with_comma_separator":
				r = a(n, 2, ".", ",");
				break;
			case "amount_with_apostrophe_separator":
				r = a(n, 2);
				break;
			case "amount_no_decimals_with_comma_separator":
				r = a(n, 0, ".", ",");
				break;
			case "amount_no_decimals_with_space_separator":
				r = a(n, 0, ".", " ")
		}
		return c.replace(s, r)
	}, Shopify.OptionSelectors = function(n, t) {
		return this.selectorDivClass = "selector-wrapper", this.selectorClass = "single-option-selector", this.variantIdFieldIdSuffix = "-variant-id", this.variantIdField = null, this.historyState = null, this.selectors = [], this.domIdPrefix = n, this.product = new Shopify.Product(t.product), this.onVariantSelected = Shopify.isDefined(t.onVariantSelected) ? t.onVariantSelected : function() {}, this.replaceSelector(n), this.initDropdown(), t.enableHistoryState && (this.historyState = new Shopify.OptionSelectors.HistoryState(this)), !0
	}, Shopify.OptionSelectors.prototype.initDropdown = function() {
		var n = {
				initialLoad: !0
			},
			t = this.selectVariantFromDropdown(n);
		if (!t) {
			var o = this;
			setTimeout(function() {
				o.selectVariantFromParams(n) || o.fireOnChangeForFirstDropdown.call(o, n)
			})
		}
	}, Shopify.OptionSelectors.prototype.fireOnChangeForFirstDropdown = function(n) {
		this.selectors[0].element.onchange(n)
	}, Shopify.OptionSelectors.prototype.selectVariantFromParamsOrDropdown = function(n) {
		var t = this.selectVariantFromParams(n);
		t || this.selectVariantFromDropdown(n)
	}, Shopify.OptionSelectors.prototype.replaceSelector = function(n) {
		var t = document.getElementById(n),
			o = t.parentNode;
		Shopify.each(this.buildSelectors(), function(a) {
			o.insertBefore(a, t)
		}), t.style.display = "none", this.variantIdField = t
	}, Shopify.OptionSelectors.prototype.selectVariantFromDropdown = function(n) {
		var t = document.getElementById(this.domIdPrefix).querySelector("[selected]");
		if (t || (t = document.getElementById(this.domIdPrefix).querySelector('[selected="selected"]')), !t) return !1;
		var o = t.value;
		return this.selectVariant(o, n)
	}, Shopify.OptionSelectors.prototype.selectVariantFromParams = function(n) {
		var t = Shopify.urlParam("variant");
		return this.selectVariant(t, n)
	}, Shopify.OptionSelectors.prototype.selectVariant = function(n, t) {
		var o = this.product.getVariantById(n);
		if (o == null) return !1;
		for (var a = 0; a < this.selectors.length; a++) {
			var r = this.selectors[a].element,
				s = r.getAttribute("data-option"),
				c = o[s];
			c != null && this.optionExistInSelect(r, c) && (r.value = c)
		}
		return typeof jQuery != "undefined" ? jQuery(this.selectors[0].element).trigger("change", t) : this.selectors[0].element.onchange(t), !0
	}, Shopify.OptionSelectors.prototype.optionExistInSelect = function(n, t) {
		for (var o = 0; o < n.options.length; o++)
			if (n.options[o].value == t) return !0
	}, Shopify.OptionSelectors.prototype.insertSelectors = function(n, t) {
		Shopify.isDefined(t) && this.setMessageElement(t), this.domIdPrefix = "product-" + this.product.id + "-variant-selector";
		var o = document.getElementById(n);
		Shopify.each(this.buildSelectors(), function(a) {
			o.appendChild(a)
		})
	}, Shopify.OptionSelectors.prototype.buildSelectors = function() {
		for (var n = 0; n < this.product.optionNames().length; n++) {
			var t = new Shopify.SingleOptionSelector(this, n, this.product.optionNames()[n], this.product.optionValues(n));
			t.element.disabled = !1, this.selectors.push(t)
		}
		var o = this.selectorDivClass,
			a = this.product.optionNames(),
			r = Shopify.map(this.selectors, function(s) {
				var c = document.createElement("div");
				if (c.setAttribute("class", o), a.length > 1) {
					var l = document.createElement("label");
					l.htmlFor = s.element.id, l.innerHTML = s.name, c.appendChild(l)
				}
				return c.appendChild(s.element), c
			});
		return r
	}, Shopify.OptionSelectors.prototype.selectedValues = function() {
		for (var n = [], t = 0; t < this.selectors.length; t++) {
			var o = this.selectors[t].element.value;
			n.push(o)
		}
		return n
	}, Shopify.OptionSelectors.prototype.updateSelectors = function(n, t) {
		var o = this.selectedValues(),
			a = this.product.getVariant(o);
		a ? (this.variantIdField.disabled = !1, this.variantIdField.value = a.id) : this.variantIdField.disabled = !0, this.onVariantSelected(a, this, t), this.historyState != null && this.historyState.onVariantChange(a, this, t)
	}, Shopify.OptionSelectorsFromDOM = function(n, t) {
		var o = t.optionNames || [],
			a = t.priceFieldExists || !0,
			r = t.delimiter || "/",
			s = this.createProductFromSelector(n, o, a, r);
		t.product = s, Shopify.OptionSelectorsFromDOM.baseConstructor.call(this, n, t)
	}, Shopify.extend(Shopify.OptionSelectorsFromDOM, Shopify.OptionSelectors), Shopify.OptionSelectorsFromDOM.prototype.createProductFromSelector = function(n, t, r, s) {
		if (!Shopify.isDefined(r)) var r = !0;
		if (!Shopify.isDefined(s)) var s = "/";
		var c = document.getElementById(n),
			l = c.childNodes,
			d = (c.parentNode, t.length),
			p = [];
		Shopify.each(l, function(h, m) {
			if (h.nodeType == 1 && h.tagName.toLowerCase() == "option") {
				var y = h.innerHTML.split(new RegExp("\\s*\\" + s + "\\s*"));
				t.length == 0 && (d = y.length - (r ? 1 : 0));
				var v = y.slice(0, d),
					S = r ? y[d] : "",
					_ = (h.getAttribute("value"), {
						available: !h.disabled,
						id: parseFloat(h.value),
						price: S,
						option1: v[0],
						option2: v[1],
						option3: v[2]
					});
				p.push(_)
			}
		});
		var f = {
			variants: p
		};
		if (t.length == 0) {
			f.options = [];
			for (var u = 0; d > u; u++) f.options[u] = "option " + (u + 1)
		} else f.options = t;
		return f
	}, Shopify.SingleOptionSelector = function(n, t, o, a) {
		this.multiSelector = n, this.values = a, this.index = t, this.name = o, this.element = document.createElement("select");
		for (var r = 0; r < a.length; r++) {
			var s = document.createElement("option");
			s.value = a[r], s.innerHTML = a[r], this.element.appendChild(s)
		}
		return this.element.setAttribute("class", this.multiSelector.selectorClass), this.element.setAttribute("data-option", "option" + (t + 1)), this.element.id = n.domIdPrefix + "-option-" + t, this.element.onchange = function(c, l) {
			l = l || {}, n.updateSelectors(t, l)
		}, !0
	}, Shopify.Image = {
		preload: function(t, o) {
			for (var a = 0; a < t.length; a++) {
				var r = t[a];
				this.loadImage(this.getSizedImageUrl(r, o))
			}
		},
		loadImage: function(t) {
			new Image().src = t
		},
		switchImage: function(t, o, a) {
			if (t && o) {
				var r = this.imageSize(o.src),
					s = this.getSizedImageUrl(t.src, r);
				a ? a(s, t, o) : o.src = s
			}
		},
		imageSize: function(t) {
			var o = t.match(/_(1024x1024|2048x2048|pico|icon|thumb|small|compact|medium|large|grande)\./);
			return o != null ? o[1] : null
		},
		getSizedImageUrl: function(t, o) {
			if (o == null) return t;
			if (o == "master") return this.removeProtocol(t);
			var a = t.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
			if (a != null) {
				var r = t.split(a[0]),
					s = a[0];
				return this.removeProtocol(r[0] + "_" + o + s)
			}
			return null
		},
		removeProtocol: function(t) {
			return t.replace(/http(s)?:/, "")
		}
	}, Shopify.OptionSelectors.HistoryState = function(n) {
		this.browserSupports() && this.register(n)
	}, Shopify.OptionSelectors.HistoryState.prototype.register = function(n) {
		window.addEventListener("popstate", function(t) {
			n.selectVariantFromParamsOrDropdown({
				popStateCall: !0
			})
		})
	}, Shopify.OptionSelectors.HistoryState.prototype.onVariantChange = function(n, t, o) {
		this.browserSupports() && (!n || o.initialLoad || o.popStateCall || Shopify.setParam("variant", n.id))
	}, Shopify.OptionSelectors.HistoryState.prototype.browserSupports = function() {
		return window.history && window.history.replaceState
	}, Shopify.theme.productMedia = {
		models: [],
		setupMedia: function() {
			var t = {
				controls: ["zoom-in", "zoom-out", "fullscreen"],
				focusOnPlay: !1
			};
			$("model-viewer").each(function(o, a) {
				a = new Shopify.ModelViewerUI(a, t), Shopify.theme.productMedia.models.push(a)
			}), $(".product-gallery__model model-viewer").on("mousedown", function() {
				Shopify.theme.productMedia.hideModelIcon(this)
			})
		},
		showModelIcon: function(t) {
			$(t).find(".button--poster, .model-icon-button-control").show()
		},
		hideModelIcon: function(t) {
			$(t).find(".button--poster, .model-icon-button-control").hide()
		}
	}, Shopify.theme.productReviews = {
		init: function() {
			($("#shopify-product-reviews").length || $(".shopify-product-reviews-badge").length) && SPR.$(document).ready(function() {
				return SPR.registerCallbacks(), SPR.initRatingHandler(), SPR.initDomEls(), SPR.loadProducts(), SPR.loadBadges()
			})
		}
	}, Shopify.theme.quantityBox = {
		init: function() {
			$("body").on("click", "[data-update-quantity]:not([disabled])", function() {
				Shopify.theme.quantityBox.updateQuantity($(this))
			}), $("body").on("keyup keydown change", ".quantity-input", function() {
				Shopify.theme.quantityBox.updateQuantity($(this))
			})
		},
		updateQuantityControls: function(t) {
			var o = t.parents(".product-quantity-box"),
				a = $(".quantity-input", o),
				r = parseInt(a.val()),
				s = 1e17;
			a.attr("max") != null && (s = a.attr("max")), r === 1 || r === 0 ? ($(".quantity-minus", o).attr("disabled", !0), $(".quantity-plus", o).attr("disabled", !1)) : r >= s ? ($(".quantity-plus", o).attr("disabled", !0), $(".quantity-minus", o).attr("disabled", !1), a.val(s)) : ($(".quantity-minus", o).attr("disabled", !1), $(".quantity-plus", o).attr("disabled", !1))
		},
		updateQuantity: function(t) {
			var o = t.parents(".product-quantity-box"),
				a = $(".quantity-input", o),
				r = o.parents("[data-line-item]").data("line-item"),
				s = parseInt(a.val()),
				c = 1e17,
				l = a.attr("min") || 0;
			if (a.attr("max") != null && (c = a.attr("max")), isNaN(s) || s < l) return a.val(l), !1;
			if (s > c) return a.val(c), !1;
			if (t.data("update-quantity") === "plus" ? s < c && (s++, a.val(s)) : t.data("update-quantity") === "minus" && s > l && (s--, a.val(s)), t.parents("[data-line-item]").length) {
				var d = o.data("line-item-key");
				Shopify.theme.quantityBox.updateCart(d, s)
			}
			Shopify.theme.quantityBox.updateQuantityControls(t)
		},
		updateCart: function updateCart(lineID, quantity) {
			$(".quantity-warning").removeClass("animated bounceIn"), $.ajax({
				type: "POST",
				url: "/cart/change.js",
				data: "quantity=".concat(quantity, "&line=").concat(lineID),
				dataType: "json",
				success: function(t) {
					var o = 0,
						a = "",
						r = $('[data-line-item="'.concat(lineID, '"]')).find(".quantity-warning"),
						s = $('[data-line-item="'.concat(lineID, '"]')).find(".product-quantity-box"),
						c = lineID - 1;
					typeof t.items[c] != "undefined" && (o = t.items[c].quantity), quantity > 0 && quantity != o && (o == 1 ? (a = Shopify.translation.product_count_one, r.text("".concat(o, " ").concat(a)), $(".quantity-minus", s).attr("disabled", !0)) : (a = Shopify.translation.product_count_other, r.text("".concat(o, " ").concat(a)))), r.addClass("animated bounceIn"), typeof Shopify.theme.jsAjaxCart != "undefined" && Shopify.theme.jsAjaxCart.updateView(), Shopify.theme.jsCart && Shopify.theme.jsCart.updateView(t, lineID)
				},
				error: function error(XMLHttpRequest, textStatus) {
					var response = eval("(" + XMLHttpRequest.responseText + ")");
					response = response.description
				}
			})
		},
		unload: function n(t) {
			$(".quantity-input").off(), $("[data-update-quantity]").off()
		}
	}, Shopify.theme.queryParameters = {}, location.search.length)
	for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split("&"); i < aCouples.length; i++) aKeyValue = aCouples[i].split("="), aKeyValue.length > 1 && (Shopify.theme.queryParameters[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]));
Shopify.theme.responsiveVideo = {
	init: function n() {
		$('iframe[src*="youtube.com"]:not(.plyr__video-wrapper iframe[src*="youtube.com"], .lazyframe iframe[src*="youtube.com"])').wrap('<div class="lazyframe" data-ratio="16:9"></div>'), $('iframe[src*="vimeo.com"]:not(.plyr__video-wrapper iframe[src*="vimeo.com"], .lazyframe iframe[src*="vimeo.com"])').wrap('<div class="lazyframe" data-ratio="16:9"></div>')
	}
};
var selectCallback = function n(t, o) {
	var a = $(".product-" + o.product.id),
		r = $(".notify-form-" + o.product.id),
		s = $(".product_form, .shopify-product-form", a),
		c = s.data("variant-inventory"),
		l = s.find(".quantity-input"),
		d = $(".notify_form__inputs"),
		p = Shopify.translation.notify_form_email,
		f = Shopify.translation.contact_email,
		u = Shopify.translation.notify_form_send,
		h = d.data("url");
	if (t) var m = Shopify.translation.email_content + t.name + " | " + h + "?variant=" + t.id;
	if (d.hasClass("customer--true")) var y = Shopify.translation.customer_email,
		v = '\n      <input type="hidden" class="notify_email input" name="contact[email]" id="contact[email]" value="'.concat(y, '" />');
	else var v = '\n      <input required type="email" class="notify_email input" name="contact[email]" id="contact[email]" placeholder="'.concat(p, '" value="').concat(f, '" />');
	var S = '\n    <input type="hidden" name="challenge" value="false" />\n    <input type="hidden" name="contact[body]" class="notify_form_message" data-body="'.concat(m, '" value="').concat(m, '" />\n    <div class="field has-addons">\n      <div class="control">\n        ').concat(v, '\n      </div>\n      <div class="control">\n        <input class="action_button button" type="submit" value="').concat(u, '" />\n      </div>\n    </div>');
	if (t && t.featured_image && a.is(":visible")) {
		var _ = $(".product-gallery__main, .js-gallery-modal", a);
		_.each(function() {
			var g = $(this),
				C = Flickity.data(this),
				V = $("img[data-image-id=".concat(t.featured_media.id, "]")).data("index");
			g.is(":visible") && C != null && C.select(V, !1, !0)
		})
	}
	var I = s.find("[data-variant-selector]");
	if (I.trigger("selectedVariantChanged"), t)
		if (c && c.forEach(function(g) {
				g.id === t.id && (t.inventory_quantity = g.inventory_quantity, t.inventory_management = g.inventory_management, t.inventory_policy = g.inventory_policy)
			}), $(".sku", a).text(t.sku), Shopify.theme_settings.product_form_style)
			for (var b = 0, q = t.options.length; b < q; b++) {
				var w = s.find('.swatch[data-option-index="' + escape(b) + '"] :radio[value="' + t.options[b].replace(/\"/g, '\\"') + '"]');
				w.length && (w.get(0).checked = !0)
			} else $(".notify_form_message", a).attr("value", $(".notify_form_message", a).data("body") + " - " + t.title);
	if (t && t.available == !0) {
		if (t.price < t.compare_at_price ? ($(".was-price", a).html('<span class="money">' + Shopify.formatMoney(t.compare_at_price, $("body").data("money-format")) + "</span>"), $(".savings", a).html(Shopify.translation.product_savings + " " + parseInt((t.compare_at_price - t.price) * 100 / t.compare_at_price) + '% (<span class="money">' + Shopify.formatMoney(t.compare_at_price - t.price, $("body").data("money-format")) + "</span>)"), $(".current_price", a).parent().addClass("sale")) : ($(".was-price", a).html(""), $(".savings", a).html(""), $(".current_price", a).parent().removeClass("sale")), t.inventory_management && t.inventory_quantity > 0) {
			if (Shopify.theme_settings.display_inventory_left) {
				var x = Shopify.translation.product_count_other;
				t.inventory_quantity == 1 && (x = Shopify.translation.product_count_one);
				var j = Shopify.theme_settings.inventory_threshold;
				t.inventory_quantity <= j ? $(".items_left", a).html(t.inventory_quantity + " " + x) : $(".items_left", a).html("")
			}
			t.inventory_policy == "deny" && ($("[data-max-inventory-management]", a).attr("max", t.inventory_quantity), Shopify.theme.quantityBox.updateQuantityControls(l))
		} else $(".items_left", a).text(""), $("[data-max-inventory-management]", a).removeAttr("max");
		$(".sold_out", a).text(""), $(".cart-warning", a).text(""), t.price > 0 ? $(".current_price", a).html('<span class="money">' + Shopify.formatMoney(t.price, $("body").data("money-format")) + "</span>") : $(".current_price", a).html(Shopify.translation.free_price_text), $("[data-add-to-cart-trigger]", a).removeClass("disabled").removeAttr("disabled").find("span:not(.icon)").text($("[data-add-to-cart-trigger]", a).data("label")), $(".shopify-payment-button", a).show(),$(".purchase-details__quantity", a).show(), r.hide(), d.empty(), d.append(S), Shopify.theme_settings.show_multiple_currencies && convertCurrencies()
        $('.klaviyo-bis-trigger').hide();
		$(".purchase-details.has-quantity-box").addClass('has-qty');
	} else {
		var k = t ? Shopify.translation.soldOut : Shopify.translation.unavailable;
		$(".was-price", a).text(""), $(".savings", a).text(""), $(".current_price", a).text(""), $(".items_left", a).text(""), $("[data-max-inventory-management]", a).removeAttr("max"), $(".sold_out", a).text(k), $("[data-add-to-cart-trigger]", a).addClass("disabled").attr("disabled", "disabled").find("span:not(.icon)").text(k), $(".shopify-payment-button", a).hide(), $(".purchase-details__quantity", a).hide(), r.hide(), d.empty(), t && !t.available && (r.fadeIn(), d.empty(), d.append(S))
        $('.klaviyo-bis-trigger').show();
		$(".purchase-details.has-quantity-box").removeClass('has-qty');
	}
};
Shopify.theme.predictiveSearch = {
	init: function n() {
		$(".search-form input#q").val(""), $(".search-form input#q").on("keyup", function() {
			var t = null,
				o = $(this).val(),
				a = $(this),
				r;
			Shopify.theme_settings.search_option == "products" ? r = "".concat($("body").data("shop-url"), "/search?type=product&q=").concat(encodeURI(o)) : r = "".concat($("body").data("shop-url"), "/search?q=").concat(encodeURI(o)), $(".search-form").on("submit", function(s) {
				var c = encodeURI(o);
				s.preventDefault(), c == null ? window.location.href = "/search" : window.location.href = "".concat(r, "*")
			}), o == "" && $(this).find(".predictive-results").empty().css("opacity", 0), o.length > 3 ? (t != null && t.abort(), t = $.getJSON(r + "*&view=json", function(s) {
				Shopify.theme.predictiveSearch.displayResults(s.results, r, o, a)
			})) : $(".search-form").find(".predictive-results").empty().css("opacity", 0)
		}), $(document).on("click", function(t) {
			var o = $(".search-form input#q");
			!o.is(t.target) && o.has(t.target).length === 0 && $(".predictive-results").css("opacity", 0).empty()
		})
	},
	displayResults: function n(t, o, a, r) {
		var s = r.parents(".search-form").find(".predictive-results");
		if (s.empty().css("opacity", 1), t.length > 0) {
			for (var c = 0; c < Shopify.theme_settings.search_to_display; c++)
				if (t[c] != null) {
					var l = t[c],
						d = void 0,
						p = void 0,
						f = void 0;
					l.object_type == "product" ? (l.available == !0 ? l.raw_price == 0 ? p = Shopify.translation.free : p = l.price : p = Shopify.translation.sold_out, l.raw_compare > l.raw_price ? d = "\n              <span class='money'>".concat(p, "</span>\n              <span class='product-thumbnail__was-price was-price'>\n                <span class='money'>").concat(l.compare, "</span>\n              </span>") : d = "<span class='money'>".concat(p, "</span>")) : d = "<span>".concat(l.text_content), l.thumbnail != "" ? f = "<img class='lazyload transition--".concat(Shopify.theme_settings.image_loading_style, " result-image' src='").concat(l.thumbnail, "' alt='").concat(l.title, "'>") : f = "", s.append("\n          <li>\n            <a class='result-link' href='".concat(l.url, "'>\n              ").concat(f, "\n              <div class='result-info'>\n                <p>").concat(l.title, "</p>\n                ").concat(d, "\n              </div>\n            </a>\n          </li>\n          "))
				} t.length > Shopify.theme_settings.search_to_display && s.append("<li><a class='result-link' href='".concat(o, "*'>").concat(Shopify.translation.all_results, "</a></li>"))
		} else s.append("<li>".concat(Shopify.translation.no_results, "</li>"))
	},
	unload: function n() {
		$(".search-form").off(), $(".search-form input#q").off()
	}
};

function isScreenSizeLarge() {
	if ($(window).width() > Shopify.breakpoints.medium) return !0
}
Shopify.theme.scrollToTop = function(n, t) {
	t != null ? $("html, body").animate({
		scrollTop: $(n).offset().top - t
	}, 1e3) : $("html, body").animate({
		scrollTop: $(n).offset().top
	}, 1e3)
}, Shopify.theme.tabs = {
	enableTabs: function n() {
		var t = $(".tabs li, .tabs li a");
		t.on("click", function(o) {
			o.preventDefault(), t.removeClass("is-active active"), $(this).addClass("is-active");
			var a = $(this).index(),
				r = $(this).parents(".tabs").next(".tabs-content");
			r.children("li, li a").removeClass("is-active active"), r.children("li, li a").eq(a).addClass("is-active").show().css({
				display: "block"
			}).siblings().hide().removeClass("is-active")
		})
	},
	unload: function n() {
		$(".tabs li, .tabs li a").off()
	}
};
var globalQuickShopProduct;
Shopify.theme.thumbnail = {
	enableSwatches: function n() {
		isScreenSizeLarge() && $("body").on("mouseenter", ".swatch span", function() {
			$(this).data("image").indexOf("no-image") == -1 && ($(this).parents(".thumbnail").find(".product__imageContainer img:not(.secondary)").attr("src", $(this).data("image")), $(this).parents(".thumbnail").find(".product__imageContainer img:not(.secondary)").attr("srcset", $(this).data("image")))
		})
	},
	showVariantImage: function n() {
		isScreenSizeLarge() && ($("body").on("mouseenter", ".has-secondary-image-swap", function() {
			var t = $(this).find(".product-image__wrapper img"),
				o = $(this).find(".product-image__wrapper .video-on-hover");
			t && t.toggleClass("swap--visible"), o && (o.toggleClass("swap--visible"), Shopify.theme.video.enableVideoOnHover($(this)))
		}), $("body").on("mouseleave", ".has-secondary-image-swap", function() {
			var t = $(this).find(".product-image__wrapper img"),
				o = $(this).find(".product-image__wrapper .video-on-hover");
			t && t.toggleClass("swap--visible"), o && (o.toggleClass("swap--visible"), Shopify.theme.video.disableVideoOnHover($(this)))
		}))
	},
	showQuickShop: function n() {
		$("body").on("click", ".js-quick-shop-link", function(t) {
			t.preventDefault();
			var o = {
					handle: $(this).data("handle"),
					product_id: $(this).data("id"),
					single_variant: $(this).attr("data-single-variant"),
					product_in_collection_url: $(this).data("url"),
					escaped_title: $(this).data("title"),
					details_text: $(this).data("details-text"),
					full_description: $(this).data("full-description"),
					regular_description: $(this).data("regular-description"),
					featured_image: $(this).data("featured-image"),
					image_array: Shopify.theme.thumbnail.createImageObjects($(this).data("images")),
					thumbnail_array: Shopify.theme.thumbnail.createImageObjects($(this).data("thumbnail-images")),
					collection_handles: $(this).data("collection-handles").trim(",").split(","),
					money_format: $("body").data("money-format")
				},
				a = $(this).next(".js-quickshop-forms__container").find(".notify_form"),
				r = $(this).next(".js-quickshop-forms__container").find(".product_form");
			$(".fancybox-active").length || $.fancybox.open($(".js-quick-shop"), {
				baseClass: "quick-shop__lightbox product-" + o.product_id,
				hash: !1,
				infobar: !1,
				toolbar: !1,
				loop: !0,
				smallBtn: !0,
				touch: !1,
				video: {
					autoStart: !1
				},
				mobile: {
					preventCaptionOverlap: !1,
					toolbar: !0
				},
				beforeLoad: function(c, l) {
					var d = l.src,
						p = $(d).find(".quick-shop");
					p.hasClass("content-loaded") || Shopify.theme.thumbnail.beforeOpen(o, p)
				},
				afterLoad: function(c, l) {
					$(".tabs").length > 0 && Shopify.theme.tabs.enableTabs(), Shopify.theme.thumbnail.afterContent(r, a, o, l), Shopify.theme.jsProduct.enableProductSwatches(), Shopify.theme.productMedia.setupMedia()
				},
				afterShow: function(c, l) {
					var d = l.src,
						p = $(d).find(".quick-shop");
					p.addClass("quick-shop--loaded")
				},
				beforeClose: function(c, l) {
					var d = l.src,
						p = $(d).find(".quick-shop");
					Shopify.theme.thumbnail.beforeClose(o, p), p.removeClass("quick-shop--loaded"), $("body").removeClass("model-loaded")
				}
			})
		})
	},
	beforeClose: function n(t, o) {
		var a = o.closest(".js-quick-shop");
		a.removeClass("content-loaded");
		var r = $(".quick-shop__lightbox .notify_form"),
			s = $(".quick-shop__lightbox .product_form");
		$(".js-quickshop-forms--".concat(t.product_id)).append(s), $(".js-quickshop-forms--".concat(t.product_id)).append(r), $(".js-quickshop-forms--".concat(t.product_id, " .product_form")).addClass("viewed"), $(".js-quickshop-forms--".concat(t.product_id, " .notify_form")).addClass("viewed"), $(".quick-shop .thumbnail-sticker span").empty().parent().addClass("is-hidden");
		var c = o.find(".js-gallery-modal"),
			l = o.find(".js-gallery-carousel");
		l.find(".gallery-cell").off("click"), c.flickity("remove", $(".gallery-cell", c)), l.empty(), c.flickity("destroy");
		var d = $(".js-current-price .money").text();
		$(".js-quick-shop-link[data-id=".concat(t.product_id, "]")).attr("data-initial-modal-price", d), $(".js-current-price, .js-was-price, .js-savings").empty(), c.data("zoom") === !0 && c.trigger("zoom.destroy")
	},
	afterContent: function n(t, o, a, r) {
		var s = r.src,
			c = $(s).find(".js-gallery-modal");
		c.closest(".js-quick-shop").addClass("content-loaded"), Shopify.theme.thumbnail.retrieveProductInfo(a);
		var l = {
			thumbnailsEnabled: c.data("thumbnails-enabled"),
			thumbnailsSliderEnabled: c.data("thumbnails-slider-enabled"),
			thumbnailsPosition: c.data("thumbnails-position"),
			arrowsEnabled: c.data("gallery-arrows-enabled"),
			slideshowAnimation: c.data("slideshow-animation"),
			slideshowSpeed: c.data("slideshow-speed")
		};
		if (Shopify.theme.jsProduct.enableSlideshow(c, l), Shopify.theme.video.init(), $(".quick-shop__lightbox .js-notify-form").append(o), $(".quick-shop__lightbox .js-product-form").append(t), t.hasClass("product_form_options") && !t.hasClass("viewed") ? new Shopify.OptionSelectors(t.data("select-id"), {
				product: t.data("product"),
				onVariantSelected: selectCallback,
				enableHistoryState: t.data("enable-state")
			}) : Shopify.theme_settings.show_multiple_currencies && convertCurrencies(), Shopify.theme_settings.product_form_style == "swatches") {
			var d = t.data("product"),
				p = a.section_id,
				f = ".product-" + p + " .js-product_section",
				u = t.find(".swatch_options .swatch");
			u.length > 1 && Shopify.linkOptionSelectors(d, f)
		}
		$(".single-option-selector").length > 0 && ($(".selector-wrapper").wrap('<div class="select"></div>'), $("#product-form-" + a.product_id + " .select-container").children().first().removeClass("select").addClass("select-container")), $('.js-quick-shop select[name="id"]').trigger("change")
	},
	createImageObjects: function n(t) {
		var o = t.split("~"),
			a = o.map(function(r) {
				var s = r.split("^");
				return {
					path: s[0],
					alt: s[1],
					id: s[2],
					width: s[3],
					mediaType: s[4]
				}
			});
		return a
	},
	beforeOpen: function n(t, o) {
		Shopify.theme.thumbnail.populateGallery(t, o), $(".js-sale-sticker, .js-sold-out, .js-current-price, .js-was-price, .js-savings, .js-new-sticker, .js-pre-order-sticker").empty(), $(".modal_price, .js-notify-form").show()
	},
	retrieveProductInfo: function n(t) {
		$.ajax({
			dataType: "json",
			async: !1,
			cache: !1,
			url: "/products/" + t.handle + ".js",
			success: function(a) {
				a = $.extend({}, a, t), globalQuickShopProduct = a, Shopify.theme.thumbnail.updateVariant(a.variants[0].id.toString(), a)
			}
		})
	},
	populateGallery: function n(t, o) {
		var a = o.find(".js-gallery-modal"),
			r = o.find(".js-gallery-carousel");

		function s() {
			$.each(t.image_array, function(l, d) {
				if (d.path == "" || d.id == null) var p = t.featured_image,
					f = "";
				else var p = d.path,
					f = d.alt;
				var u = p.replace(/(\.[^.]*)$/, "_2048x2048$1").replace("http:", ""),
					h;
				d.mediaType.indexOf("image") >= 0 ? h = '\n            <div class="image__container" style="max-width: '.concat(d.width, 'px">\n              <img src="').concat(p, '" alt="').concat(f, '" data-image-id="').concat(d.id, '" data-index="').concat(l, '" />\n            </div>\n          ') : h = unescape(p);
				var m = $('<div class="gallery-cell">' + h + "</div>");
				a.append(m)
			})
		}

		function c() {
			$.each(t.thumbnail_array, function(l, d) {
				if (d.path != "") {
					var p = d.path,
						f = p.replace(/(\.[^.]*)$/, "_grande$1").replace("http:", ""),
						u = "";
					d.alt.indexOf("model") >= 0 ? u = '<span class="icon media-badge"><svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M1 25H25V1H1V25Z" fill=""/><path class="media-badge__outline" d="M0.5 25V25.5H1H25H25.5V25V1V0.5H25H1H0.5V1V25Z" stroke="" stroke-opacity="0.05"/><g opacity="0.6"><path fill-rule="evenodd" clip-rule="evenodd" d="M13 6L19.0622 9.5V16.5L13 20L6.93782 16.5V9.5L13 6Z" stroke="" stroke-width="1.5"/><path fill-rule="evenodd" clip-rule="evenodd" d="M13 20V12.6024C13.6225 12.2002 13.6225 12.2002 13.6225 12.2002L19 9V16.4082L13 20Z" fill=""/></g></svg></span>' : (d.alt.indexOf("external_video") >= 0 || d.alt.indexOf("video") >= 0) && (u = '<span class="icon media-badge"><svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M1 25H25V1H1V25Z" fill=""/><path class="media-badge__outline" d="M0.5 25V25.5H1H25H25.5V25V1V0.5H25H1H0.5V1V25Z" stroke="" stroke-opacity="0.05"/><path fill-rule="evenodd" clip-rule="evenodd" d="M8.19995 5.8V20.2L19.3999 12.5858L8.19995 5.8Z" fill="" fill-opacity="0.6"/></svg></span>');
					var h = '<img src="' + f + '" alt="' + escape(d.alt) + '" />',
						m = $('<div class="gallery-cell" tabindex="0">' + h + u + "</div>");
					r.append(m)
				}
			})
		}
		s(), r.find(".gallery-cell").length == 0 && a.find(".gallery-cell").length > 1 && c(), a.data("zoom") === !0 && a.find("img").wrap('<span class="zoom-container"></span>').css("display", "block").parent().zoom({
			touch: !1
		})
	},
	updateVariant: function n(t) {
		if (globalQuickShopProduct != "undefined") {
			var o = function(l) {
					l.id == l.id.toString() && (Shopify.theme_settings.stickers_enabled && l.compare_at_price > l.price && $(".sale-sticker span").html(Shopify.translation.sale).parent().removeClass("is-hidden"), l.compare_at_price > l.price ? $(".js-current-price").addClass("sale") : $(".js-current-price").removeClass("sale"), l.available == !1 ? a.collection_handles.indexOf("coming-soon") != -1 ? Shopify.theme_settings.stickers_enabled || $(".js-sold-out").html(Shopify.translation.coming_soon) : $(".js-sold-out").html(Shopify.translation.sold_out) : $(".js-sold-out").html(""), l.available == !0 ? ($(".js-notify-form").hide(), l.compare_at_price > l.price && ($(".js-was-price").html('<span class="money">' + Shopify.formatMoney(l.compare_at_price, a.money_format) + "</span>"), $(".js-savings").html(Shopify.translation.savings + " " + parseInt((l.compare_at_price - l.price) * 100 / l.compare_at_price) + '% (<span class="money">' + Shopify.formatMoney(l.compare_at_price - l.price, a.money_format) + "</span>)")), a.price == Shopify.translation.coming_soon ? $(".js-current-price").html(Shopify.translation.coming_soon) : l.price ? $(".js-current-price").html('<span class="money">' + Shopify.formatMoney(l.price, a.money_format) + "</span>") : $(".js-current-price").html(Shopify.translation.free_price_text), Shopify.theme_settings.show_multiple_currencies && convertCurrencies()) : $(".js-notify-form").show())
				},
				a = globalQuickShopProduct;
			$(".js-current-price").html(""), $(".js-was-price").html(""), $(".js-savings").html(""), $(".js-product-title").html('<a href="' + a.product_in_collection_url + '" title="' + a.escaped_title + '">' + a.title + "</a>"), $(".js-product-vendor").html('<a href="/collections/vendors?q=' + a.vendor + '">' + a.vendor + "</a>"), $(".js-full-description").html(a.full_description), $(".js-regular-description").html(a.regular_description);
			var r = '<a href="' + a.product_in_collection_url + '" class="secondary_button" title="' + a.escaped_title + ' Details">' + a.details_text + "</a>";
			if ($(".js-product-details").html(r), Shopify.theme_settings.stickers_enabled && $.each(a.collection_handles, function(c, l) {
					switch (this.toString()) {
						case "best-seller":
							$(".best-seller-sticker span").html(Shopify.translation.best_seller).parent().removeClass("is-hidden");
							break;
						case "coming-soon":
							$(".coming-soon-sticker span").html(Shopify.translation.coming_soon).parent().removeClass("is-hidden");
							break;
						case "new":
							$(".new-sticker span").html(Shopify.translation.new_sticker).parent().removeClass("is-hidden");
							break;
						case "pre-order":
							$(".pre-order-sticker span").html(Shopify.translation.pre_order).parent().removeClass("is-hidden");
							break;
						case "staff-pick":
							$(".staff-pick-sticker span").html(Shopify.translation.staff_pick).parent().removeClass("is-hidden")
					}
				}), a.single_variant == "true") o(a);
			else
				for (var s = 0; s < a.variants.length; s++) o(a.variants[s])
		}
	}
};
var videoEl = {
		playButtonIcon: '<button type="button" class="plyr__control plyr__control--overlaid" aria-label="Play, {title}" data-plyr="play"><svg class="play-icon-button-control" width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="60" height="60" fill="white"/><path fill-rule="evenodd" clip-rule="evenodd" d="M23 20V40L39 29.4248L23 20Z" fill="#323232"/></svg><span class="plyr__sr-only">Play</span></button>',
		playButton: '<button type="button" class="plyr__controls__item plyr__control" aria-label="Play, {title}" data-plyr="play"><svg class="icon--pressed" role="presentation"><use xlink:href="#plyr-pause"></use></svg><svg class="icon--not-pressed" role="presentation"><use xlink:href="#plyr-play"></use></svg><span class="label--pressed plyr__tooltip" role="tooltip">Pause</span><span class="label--not-pressed plyr__tooltip" role="tooltip">Play</span></button>',
		muteButton: '<button type="button" class="plyr__controls__item plyr__control" aria-label="Mute" data-plyr="mute"><svg class="icon--pressed" role="presentation"><use xlink:href="#plyr-muted"></use></svg><svg class="icon--not-pressed" role="presentation"><use xlink:href="#plyr-volume"></use></svg><span class="label--pressed plyr__tooltip" role="tooltip">Unmute</span><span class="label--not-pressed plyr__tooltip" role="tooltip">Mute</span></button>',
		progressInput: '<div class="plyr__controls__item plyr__progress__container"><div class="plyr__progress"><input data-plyr="seek" type="range" min="0" max="100" step="0.01" value="0" aria-label="Seek"><progress class="plyr__progress__buffer" min="0" max="100" value="0">% buffered</progress><span role="tooltip" class="plyr__tooltip">00:00</span></div></div>',
		volume: '<div class="plyr__controls__item plyr__volume"><input data-plyr="volume" type="range" min="0" max="1" step="0.05" value="1" autocomplete="off" aria-label="Volume"></div>',
		fullscreen: '<button type="button" class="plyr__controls__item plyr__control" data-plyr="fullscreen"><svg class="icon--pressed" role="presentation"><use xlink:href="#plyr-exit-fullscreen"></use></svg><svg class="icon--not-pressed" role="presentation"><use xlink:href="#plyr-enter-fullscreen"></use></svg><span class="label--pressed plyr__tooltip" role="tooltip">Exit fullscreen</span><span class="label--not-pressed plyr__tooltip" role="tooltip">Enter fullscreen</span></button>'
	},
	videoControls = "".concat(videoEl.playButtonIcon, '<div class="plyr__controls"> ').concat(videoEl.playButton, " ").concat(videoEl.progressInput, " ").concat(videoEl.muteButton, " ").concat(videoEl.volume, " ").concat(videoEl.fullscreen, "</div>"),
	videoPlayers = [],
	videosInRecommendedProductsPlayer;
Shopify.theme.video = {
	init: function n() {
		this.setupVideoPlayer()
	},
	setupVideoPlayer: function n() {
		var t = document.querySelectorAll("[data-html5-video] video, [data-youtube-video]"),
			o = Plyr.setup(t, {
				controls: videoControls,
				ratio: this.aspect_ratio,
				fullscreen: {
					enabled: !0,
					fallback: !0,
					iosNative: !0
				},
				storage: {
					enabled: !1
				}
			}),
			a = $("[data-video-loop]").data("video-loop") || !1;
		$.each(o, function(r, s) {
			s.loop = a, videoPlayers.push(s)
		}), this.setupListeners()
	},
	setupListeners: function n() {
		$.each(videoPlayers, function(t, o) {
			var a = o.id,
				r;
			o.isHTML5 && (r = $(o.elements.wrapper).find("video"), r.attr("data-plyr-video-id", a)), o.on("play", function(s) {
				var c = s.detail.plyr;
				$.each(videoPlayers, function(l, d) {
					var p = d.id || d.media.dataset.plyrVideoId;
					c.id != p && d.pause()
				})
			})
		})
	},
	enableVideoOnHover: function n(t) {
		var o = t.find("[data-html5-video]"),
			a = t.find("[data-youtube-video]"),
			r;
		o.length > 0 ? r = o.find("[data-plyr-video-id]").data("plyr-video-id") : a.length > 0 && (r = a.find("iframe").attr("id")), r && $.each(videoPlayers, function(s, c) {
			(c.id == r || c.media.id == r) && (c.toggleControls(!1), c.muted = !0, c.play())
		})
	},
	disableVideoOnHover: function n(t) {
		var o = t.find("[data-html5-video]"),
			a = t.find("[data-youtube-video]"),
			r;
		o.length > 0 ? r = o.find("[data-plyr-video-id]").data("plyr-video-id") : a.length > 0 && (r = a.find("iframe").attr("id")), r && $.each(videoPlayers, function(s, c) {
			(c.id == r || c.media.id == r) && c.playing && c.pause()
		})
	}
};